import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";
import analytics from "../../assets/icons/ecommerce.png";
import testing from "../../assets/icons/cms.png";
import optimization from "../../assets/icons/optimize.png";

const BAservice = () => {
  return (
    <div className="sf-services">
      <h3>Our Business Automation Services</h3>
      <p className="sf-description">
        We offer complete <b>business automation services </b> offerings
        designed to meet the precise needs of your enterprise. Our answers are
        tailored to help you streamline operations, reduce fees, and enhance
        performance.
      </p>
      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>Workflow Automation </h3>
          <p>
            We help you design and implement efficient workflows to automate
            business processes and ensure smooth operations across departments.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>CRM Automation </h3>
          <p>
            Manage customer interactions more effectively with automated CRM
            systems that enhance engagement and improve sales performance.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>System Integration & API Setup </h3>
          <p>
            Connect your existing tools and platforms seamlessly. We integrate
            your CRM, email, accounting software, and other systems to create a
            unified business ecosystem.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={analytics} alt="Funnel Analytics" />
          </div>
          <h3> Automated Lead Nurturing</h3>
          <p>
            Build automated campaigns that nurture leads through the sales
            funnel. Our systems qualify leads, send personalized messages, and
            hand off ready-to-close leads to your sales team.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={testing} alt="A/B Testing" />
          </div>
          <h3>Email Marketing Automation</h3>
          <p>
            Set up automated email sequences triggered by customer actions. We
            design campaigns that engage prospects, nurture relationships, and
            drive repeat business.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Automated Reporting & Analytics</h3>
          <p>
            Generate automated reports that track key metrics and business
            performance. Real-time dashboards provide visibility into your
            operations and help you make data-driven decisions.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Sales Automation</h3>
          <p>
            Simplify your sales pipeline with automation tools that help track
            leads, follow-ups, and conversions efficiently.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Customer Support Automation</h3>
          <p>
            Enhance customer experience with automated chatbots and support
            systems that provide instant responses and solutions.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={optimization}
              alt="Advanced Optimization"
            />
          </div>
          <h3>Implementation & Ongoing Support</h3>
          <p>
            We handle complete setup, training, and ongoing support. Our team
            ensures smooth deployment and optimization of your automation
            systems for continuous improvement.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BAservice;
